const expandRow = (row) => {
  row.table.setExpanded((expanded) =>
    expanded === true ? expanded : { ...expanded, [row.id]: true }
  );
};

export default expandRow;
